import { StateOption } from "../types/state_option";

export const states: StateOption = {
    activeDbName: "null",
    isPageLoaded: false,
    activeTab: 0
}